// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Calendar container styles */
.calendar-container {
  margin: 0 3vw;
}

.react-calendar {
  border: none;
}

/* Calendar header styles */
.react-calendar__navigation {
  /* Header background color */
  color: #fff;
  /* Header text color */
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;

  >button {
    color: var(--Primary-Color, #0877BC);
    text-align: center;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 1px;

    >img {
      height: 30px;
      filter: brightness(0) saturate(100%) invert(23%) sepia(92%) saturate(2056%) hue-rotate(185deg) brightness(103%) contrast(94%);
      /* background-color: rgba(0, 0, 0, 0.164); */
      border-radius: 1200px;
    }
  }
}

.react-calendar__month-view__days__day--neighboringMonth {
  color: rgba(52, 51, 57, 0.253) !important;

}

.react-calendar__viewContainer {
  border-radius: 8px;
  background: rgba(8, 119, 188, 0.09);
  box-shadow: 0px 2px 48px 0px rgba(0, 0, 0, 0.04);
}

.react-calendar__month-view__weekdays__weekday {
  color: var(--Primary-Color, #0877BC);
  text-align: center;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 1px;

  >abbr {
    text-decoration: none;
  }
}

/* Calendar day styles */
.react-calendar__month-view__days__day {
  height: 38px !important;
  color: rgba(52, 51, 57, 0.72);
  text-align: center;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 1px;
  padding: 0 !important;

  >abbr {
    align-items: center;
    display: flex;
    justify-content: center;
    border-radius: 100%;
    height: 9vw;

    margin: 0 5px;

  }
}

.react-calendar__tile--now {
  background: none !important;

  >abbr {
    background: #0a80ff42;
  }
}

.react-calendar__month-view__days__day:hover {
  background: none !important;

  >abbr {
    background: #0877bc70 !important;

  }
}

/* Calendar day styles (selected day) */
.react-calendar__tile--active {
  background: none !important;

  >abbr {
    background-color: #0a80ff;
    /* Selected day background color */
    color: #ffffff;
    /* Selected day text color */
  }
}

/* Calendar navigation button styles */
.react-calendar__navigation__label {
  font-size: 16px;
}

.react-calendar__navigation button:enabled:hover,
.react-calendar__navigation button:enabled:focus {
  background: none;

  >img {
    opacity: 0.7;
  }
}

/* Calendar navigation button styles (disabled) */
.react-calendar__navigation__arrow--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/Calendar.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,4BAA4B;EAC5B,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;;EAEb;IACE,oCAAoC;IACpC,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;;IAEnB;MACE,YAAY;MACZ,6HAA6H;MAC7H,4CAA4C;MAC5C,qBAAqB;IACvB;EACF;AACF;;AAEA;EACE,yCAAyC;;AAE3C;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,gDAAgD;AAClD;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;;EAEnB;IACE,qBAAqB;EACvB;AACF;;AAEA,wBAAwB;AACxB;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;;EAErB;IACE,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;;IAEX,aAAa;;EAEf;AACF;;AAEA;EACE,2BAA2B;;EAE3B;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,2BAA2B;;EAE3B;IACE,gCAAgC;;EAElC;AACF;;AAEA,uCAAuC;AACvC;EACE,2BAA2B;;EAE3B;IACE,yBAAyB;IACzB,kCAAkC;IAClC,cAAc;IACd,4BAA4B;EAC9B;AACF;;AAEA,sCAAsC;AACtC;EACE,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;;EAEhB;IACE,YAAY;EACd;AACF;;AAEA,iDAAiD;AACjD;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* Calendar container styles */\r\n.calendar-container {\r\n  margin: 0 3vw;\r\n}\r\n\r\n.react-calendar {\r\n  border: none;\r\n}\r\n\r\n/* Calendar header styles */\r\n.react-calendar__navigation {\r\n  /* Header background color */\r\n  color: #fff;\r\n  /* Header text color */\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 10px;\r\n\r\n  >button {\r\n    color: var(--Primary-Color, #0877BC);\r\n    text-align: center;\r\n    font-family: Poppins;\r\n    font-size: 16px;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    line-height: normal;\r\n    letter-spacing: 1px;\r\n\r\n    >img {\r\n      height: 30px;\r\n      filter: brightness(0) saturate(100%) invert(23%) sepia(92%) saturate(2056%) hue-rotate(185deg) brightness(103%) contrast(94%);\r\n      /* background-color: rgba(0, 0, 0, 0.164); */\r\n      border-radius: 1200px;\r\n    }\r\n  }\r\n}\r\n\r\n.react-calendar__month-view__days__day--neighboringMonth {\r\n  color: rgba(52, 51, 57, 0.253) !important;\r\n\r\n}\r\n\r\n.react-calendar__viewContainer {\r\n  border-radius: 8px;\r\n  background: rgba(8, 119, 188, 0.09);\r\n  box-shadow: 0px 2px 48px 0px rgba(0, 0, 0, 0.04);\r\n}\r\n\r\n.react-calendar__month-view__weekdays__weekday {\r\n  color: var(--Primary-Color, #0877BC);\r\n  text-align: center;\r\n  font-family: Poppins;\r\n  font-size: 12px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: normal;\r\n  letter-spacing: 1px;\r\n\r\n  >abbr {\r\n    text-decoration: none;\r\n  }\r\n}\r\n\r\n/* Calendar day styles */\r\n.react-calendar__month-view__days__day {\r\n  height: 38px !important;\r\n  color: rgba(52, 51, 57, 0.72);\r\n  text-align: center;\r\n  font-family: Poppins;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: normal;\r\n  letter-spacing: 1px;\r\n  padding: 0 !important;\r\n\r\n  >abbr {\r\n    align-items: center;\r\n    display: flex;\r\n    justify-content: center;\r\n    border-radius: 100%;\r\n    height: 9vw;\r\n\r\n    margin: 0 5px;\r\n\r\n  }\r\n}\r\n\r\n.react-calendar__tile--now {\r\n  background: none !important;\r\n\r\n  >abbr {\r\n    background: #0a80ff42;\r\n  }\r\n}\r\n\r\n.react-calendar__month-view__days__day:hover {\r\n  background: none !important;\r\n\r\n  >abbr {\r\n    background: #0877bc70 !important;\r\n\r\n  }\r\n}\r\n\r\n/* Calendar day styles (selected day) */\r\n.react-calendar__tile--active {\r\n  background: none !important;\r\n\r\n  >abbr {\r\n    background-color: #0a80ff;\r\n    /* Selected day background color */\r\n    color: #ffffff;\r\n    /* Selected day text color */\r\n  }\r\n}\r\n\r\n/* Calendar navigation button styles */\r\n.react-calendar__navigation__label {\r\n  font-size: 16px;\r\n}\r\n\r\n.react-calendar__navigation button:enabled:hover,\r\n.react-calendar__navigation button:enabled:focus {\r\n  background: none;\r\n\r\n  >img {\r\n    opacity: 0.7;\r\n  }\r\n}\r\n\r\n/* Calendar navigation button styles (disabled) */\r\n.react-calendar__navigation__arrow--disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
